import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';

interface AmendmentReasonModalProps {
  reason: string | null;
  onClose: () => void;
}

const AmendmentReasonModal = ({ reason, onClose }: AmendmentReasonModalProps) => {
  return (
    <Dialog open={!!reason} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle sx={{ px: 4, pt: 3, pb: 2, fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', letterSpacing: '-0.025em' }}>
        Motivo de la enmienda
      </DialogTitle>
      <DialogContent dividers sx={{ px: 4, pt: 3, pb: 2 }}>
        <div className='p-4 bg-slate-50 text-slate-600 rounded-md border border-slate-100 italic text-[15px] whitespace-pre-wrap leading-relaxed shadow-sm'>
          "{reason}"
        </div>
      </DialogContent>
      <DialogActions className='px-8 pb-6 pt-5 gap-3'>
        <GlobalButton variant={GlobalButtonVariant.primaryButton} action={onClose}>
          Cerrar
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default AmendmentReasonModal;
